import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import useSettings from '../hooks/useSettings';

// ----------------------------------------------------------------------

Logo.propTypes = {
  className: PropTypes.string
};

function Logo({ className, ...other }) {
  const { themeMode } = useSettings();
  return (
    <Box
      component="img"
      alt="logo"
      src={
        themeMode === 'dark'
          ? '/static/images/light-logo.png'
          : '/static/images/logo.jpeg'
      }
      height={40}
      className={className}
      {...other}
    />
  );
}

export default Logo;
